<template>
  <div class="container create-account">
    <progress-bar :full_length="progress_bar_length" :percentage_complete="67" />
    <div class="sign-up-title">{{ title }}</div>
    <div class="sign-up-explainer">{{ explainer }}</div>
    <div class="errors" v-if="errors.length">
      <ul>
        <li class="error" v-for="error in errors" v-bind:key="error">{{ error }}</li>
      </ul>
    </div>
    <div class="input-container">
      <div class="row">
        <div class="col-md">
          <fg-input type="text"
                    label="First Name"
                    placeholder=""
                    :isRequired=true
                    v-model="first_name"
                    @keyup.enter.native="onNextClicked">
          </fg-input>
        </div>
        <div class="col-md">
          <fg-input type="text"
                    label="Last Name"
                    placeholder=""
                    :isRequired=true
                    v-model="last_name"
                    @keyup.enter.native="onNextClicked">
          </fg-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md">
          <fg-input type="text"
                    label="Company Name"
                    placeholder=""
                    :isRequired="true"
                    v-model="company_name"
                    @keyup.enter.native="onNextClicked">
          </fg-input>
        </div>
        <div class="col-md">
          <fg-select label="Company Type"
                     :options="['Restaurant', 'Online Retail Store', 'Physical Retail Store']"
                     v-model="company_type"
                     :isRequired="true"
                     @keyup.enter.native="onNextClicked">
          </fg-select>
        </div>
      </div>
      <div class="row">
        <div class="col-md">
          <fg-input type="password"
                    label="Create Password"
                    placeholder=""
                    :isRequired=true
                    v-model="password"
                    @keyup.enter.native="onNextClicked">
          </fg-input>
        </div>
        <div class="col-md">
          <fg-input type="password"
                    label="Confirm Password"
                    placeholder=""
                    :isRequired=true
                    v-model="password_confirmation"
                    @keyup.enter.native="onNextClicked">
          </fg-input>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <checkbox v-model="terms_of_service_agreement" @keyup.enter.native="onNextClicked">
            <template>
              <div v-html="terms_of_service"></div>
            </template>
          </checkbox>
        </div>
      </div>
    </div>
    <div class="button-row row justify-content-center">
      <default-button :buttonText="button_title" :processing-click="creating_account" v-on:onButtonClicked="onNextClicked" :disabled="hasEmptyField" />
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  import ProgressBar from '@/components/UIComponents/ProgressBar/ProgressBar.vue'
  import Checkbox from '@/components/UIComponents/Inputs/Checkbox.vue'
  import DefaultButton from '@/components/UIComponents/Buttons/DefaultButton.vue'

  export default {
    components: {
      ProgressBar,
      Checkbox,
      DefaultButton,
    },
    props: {
      email: String,
    },
    data () {
      return {
        errors: [],
        progress_bar_length: 400,
        title: 'Create Your Account',
        explainer: "You're one step away from engaging with new customers.",
        first_name: '',
        last_name: '',
        company_name: '',
        company_type: '',
        password: '',
        password_confirmation: '',
        terms_of_service_agreement: false,
        terms_of_service: 'I agree to the <a href="https://s3-us-west-2.amazonaws.com/plyo-merchant-resources/Plyo+Merchant+Terms+of+Use.pdf" target="_blank">Terms of Use</a> ',
        button_title: 'CREATE ACCOUNT',
        creating_account: false,
      }
    },
    methods: {
      async onNextClicked () {
        if (!this.hasEmptyField) {
          this.checkForErrors();
          if (!this.errors.length) {
            var payload = {
              email: this.email,
              first_name: this.first_name,
              last_name: this.last_name,
              company_name: this.company_name,
              company_type: this.company_type,
              password: this.password,
            }

            this.creating_account = true;
            await axios.post(this.$store.state.endpoints.signUp, payload)
              .then((response)=>{
                  const signin_payload = {
                    username_or_email: payload.email,
                    password: payload.password,
                  }

                  axios.post(this.$store.state.jwt.endpoints.obtainJWT, signin_payload)
                    .then((response)=>{
                        this.$store.dispatch('setToken', response.data.token);
                        this.$store.dispatch('updateFirstTime', true);
                        this.$router.push('/');
                      })
                    .catch((error)=>{
                        this.errors.push('Account created. Login error.');
                      })
                })
              .catch((error)=>{
                this.errors.push('Unknown error. Please contact support at team@plyoapp.com');
              })
            this.creating_account = false;
          }
        }
      },
      checkForErrors () {
        this.errors = [];
        if (this.first_name.length === 0) {
          this.errors.push('First Name is required')
        }
        if (this.last_name.length === 0) {
          this.errors.push('Last Name is required')
        }
        if (this.company_name.length === 0) {
          this.errors.push('Company Name is required')
        }
        if (this.company_type.length === 0) {
          this.errors.push('Company Type is required')
        }
        if (this.password.length === 0) {
          this.errors.push('Password is required')
        } else {
          if (this.password != this.password_confirmation) {
            this.errors.push('Passwords do not match')
          }
        }
        if (!this.terms_of_service_agreement) {
          this.errors.push('Please read and accept the terms of use')
        }
      },
      handleResize () {
        if (window.innerWidth < 992) {
          this.progress_bar_length = window.innerWidth * 0.5;
        } else {
          this.progress_bar_length = 400;
        }
      },
    },
    computed: {
      hasEmptyField () {
        return (this.first_name.length === 0 ||
          this.last_name.length === 0 ||
          this.company_name.length === 0 ||
          this.company_type.length === 0 ||
          this.password.length === 0 ||
          this.password_confirmation.length === 0||
          !this.terms_of_service_agreement)
      },
    },
    mounted () {
      window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy: function () {
      window.removeEventListener('resize', this.handleResize)
    },
  }
</script>
